import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { HelpDialogItem, HelpDialogUpdate } from "ng/src/app/core/help-dialog/help-dialog.model";
import { Nullable } from "ng/src/app/shared/model/app.model";

@Injectable({ providedIn: 'root' })
export class HelpDialogService {
	readonly next$ = new BehaviorSubject(Nullable.of<HelpDialogUpdate>());
	
	next(update?: Nullable<HelpDialogUpdate> | HelpDialogItem[]) {
		this.next$.next(!update
			? null
			: Array.isArray(update)
				? { items: update }
				: { items: update.items, index: update.index }
		);
	}
}